export function calculateFees(sessionFee, feeConfig) {
  const fee = parseFloat(sessionFee) || 0;
  const seekerServiceFeePercentage = parseFloat(feeConfig) || 0; // 14% for seeker
  const sharerServiceFeePercentage =
    parseFloat(
      process.env.SHARER_SERVICE_FEE ||
        process.env.NEXT_PUBLIC_SHARER_SERVICE_FEE
    ) || 3; // 3% for sharer

  const MIN_SERVICE_FEE =
    parseFloat(process.env.NEXT_PUBLIC_SEEKER_MIN_SERVICE_FEE) || 0;

  let seekerServiceFee, sharerDeductionFee, seekerTotalFeeDue, sharerFeeNet;

  if (fee === 0) {
    seekerServiceFee = MIN_SERVICE_FEE;
    sharerDeductionFee = 0;
    seekerTotalFeeDue = fee + seekerServiceFee;
    sharerFeeNet = fee; // Sharer receives $0.
  } else {
    // Calculate seeker service fee (14%)
    const calculatedSeekerFee = fee * (seekerServiceFeePercentage / 100);
    seekerServiceFee = Math.max(calculatedSeekerFee, MIN_SERVICE_FEE);

    // Calculate sharer deduction fee (3%)
    sharerDeductionFee = fee * (sharerServiceFeePercentage / 100);

    // Round to 2 decimal places to avoid floating point issues
    seekerServiceFee = Math.round(seekerServiceFee * 100) / 100;
    sharerDeductionFee = Math.round(sharerDeductionFee * 100) / 100;

    // Calculate totals
    seekerTotalFeeDue = fee + seekerServiceFee;
    sharerFeeNet = fee - sharerDeductionFee;

    // Round final amounts to 2 decimal places
    seekerTotalFeeDue = Math.round(seekerTotalFeeDue * 100) / 100;
    sharerFeeNet = Math.round(sharerFeeNet * 100) / 100;
  }

  return {
    seekerServiceFee,
    sharerDeductionFee,
    seekerTotalFeeDue,
    sharerFeeNet,
  };
}
